import i18n from '@/i18n/config';
import { BPMN_SHAPES } from '../bpmn/BpmnShapes.defs';
import { AI_FLOWCHART_SHAPES } from './FlowchartShapes.defs';

const toTitleCaseFromId = (value: string): string =>
  value
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getTranslatedFlowchartShapeLabel = (variant: string): string => {
  const mapped = variant === 'data' ? 'input-output' : variant;
  const def = (AI_FLOWCHART_SHAPES as Record<string, { text?: string }>)[mapped];
  const fallback = def?.text ?? toTitleCaseFromId(mapped);
  return i18n.t(`diagram:shapes.flowchartLabels.${mapped}`, { defaultValue: fallback }) as string;
};

export const getTranslatedBpmnShapeLabel = (variant: string): string => {
  const def = (BPMN_SHAPES as Record<string, { text?: string }>)[variant];
  const fallback = def?.text ?? toTitleCaseFromId(variant.replace(/^bpmn-/, ''));
  return i18n.t(`diagram:shapePicker.bpmnShapes.${variant}`, { defaultValue: fallback }) as string;
};
